export default __webpack_public_path__ + "media/images/payments/paypal-dc2efc6db048fbc11b6e01d7624250c3.svg";